module.exports = __webpack_public_path__ + "img/BoxPickingS1Page.7baecaab.png";